import { Link, NavLink } from 'react-router-dom'
import { useAuth } from '../auth'

export default function Header() {
  const {user,loading,login,logout} = useAuth()
  return <header className="site-header">
    <div className="container header-inner">
      <Link className="brand" to="/"><span className="radar-mark">⌖</span><span>ФФ Радар</span></Link>
      <nav>
        <NavLink to="/catalog">Каталог</NavLink>
        <NavLink to="/seller/request">Найти фулфилмент</NavLink>
        <NavLink to="/dashboard">Добавить фулфилмент</NavLink>
      </nav>
      <div className="auth-area">
        {!loading && !user && <button className="button secondary" onClick={() => void login()}>Войти через MAX</button>}
        {user && <>
          <Link className="user-link" to="/dashboard">{user.display_name || `+${user.phone_normalized}`}</Link>
          <button className="link-button" onClick={() => void logout()}>Выйти</button>
        </>}
      </div>
    </div>
  </header>
}
